<template>
  <div v-if="integral">
    <div class="q_pad_lr15px q_mar_t15px" >
      <div class="q_center q_mar_b20px">
          <p class="q_bold q_mar_b10px q_text_l">兑换码</p>
          <!--          <span class="q_bold q_color_default">{{ integral.cdkey }}</span>-->
          <vue-qr
              ref="qrCode"
              :text="textValue"
              :logoSrc="logoPath"
              :logoScale="0.2"
              :size="200"
          />

        <div class="q_text_s q_color_gray q_mar_t10px">请勿随意将兑换码展示给别人</div>
      </div>
      <div class="q_excha q_bor_bottom q_pad_tb15px" @click="goToExchangedea()" v-if="goods">
        <div class="q_vertical_left">
          <van-image fit="cover" :src="convertImg(goods.pic)"/>
          <div class="q_inlineblock q_mar_l10px q_excha_cen">
            <p class="q_mar_b10px q_text_m q_moit2 q_bold">{{ goods.name }}</p>
            <p class="q_mar_t10px q_text_s q_color_gray">{{ goods.integral }}积分</p>
          </div>
        </div>
      </div>
      <div class="q_text_l q_bold q_mar_t15px q_mar_b10px">详细信息</div>
    </div>
    <van-cell title="兑换状态" :value="integral.cdType=='0'?'待领取':'已领取'"/>
    <van-cell title="兑换时间" :value="integral.createTime"/>
    <van-cell title="使用积分" :value="integral.score+'积分'"/>
    <!-- 领取时间在兑换状态为已领取时出现 -->
    <van-cell title="领取时间" :value="integral.drawTime==null?'未领取':integral.drawTime"/>
  </div>
</template>

<script>
import {listIntegralById} from "@/api/integral";
import {wxCloseShare} from "@/utils/jiutang";
import VueQr from 'vue-qr'
export default {
  name: 'Exchangedea',
  props: {
    msg: String
  },
  components: {VueQr},
  data() {
    return {
      integralId: '',
      goods: undefined,
      integral: undefined,
      textValue: '',
      logoPath: '',
    }
  },
  created() {
    wxCloseShare()
    this.integralId = this.$route.query.id;
    this.init()
  },
  methods: {
    init() {
      this.$modal.loading()
      //获取兑换页面数据
      listIntegralById(this.integralId).then(res => {
        this.goods = res.data.goods
        this.integral = res.data.integral
        this.textValue = this.integral.cdkey
        // this.logoPath = this.goods.pic
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToExchangdea() {
      this.$router.push({
        path: '/home/Exchangdea'
      });
    },
  }
}
</script>
<style scoped="scoped">
.q_excard {
  text-align: center;
  width: 250px;
  background-color: #f2f3f7;
  margin: 20px auto;
  padding: 20px 0;
  border-radius: 5px;
}

.q_excard span {
  font-size: 20px;
}

.q_excha .van-image {
  width: 70px;
  height: 70px;
}

.q_excha >>> .van-image__img {
  border-radius: 5px;
}

.q_excha_cen .q_moit2 {
  width: 270px;
}

.code {
  text-align: center;
}
</style>
